const MAX_IMAGE_EDGE = 800;

export function isExternalProductImage(reference: string | null | undefined) {
  return /^https:\/\//i.test(reference?.trim() ?? '');
}

export function validateExternalProductImageUrl(value: string) {
  const trimmed = value.trim();
  if (!trimmed) return null;

  try {
    const url = new URL(trimmed);
    if (
      url.protocol !== 'https:' ||
      !url.hostname ||
      url.username ||
      url.password ||
      trimmed.length > 2_048
    ) {
      return 'URL slike mora biti veljaven naslov HTTPS.';
    }
  } catch {
    return 'URL slike mora biti veljaven naslov HTTPS.';
  }

  return null;
}

export async function resizeProductImage(file: File): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(
    1,
    MAX_IMAGE_EDGE / Math.max(bitmap.width, bitmap.height),
  );
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(bitmap.width * scale));
  canvas.height = Math.max(1, Math.round(bitmap.height * scale));
  const context = canvas.getContext('2d');
  if (!context) {
    bitmap.close();
    throw new Error('Slike ni bilo mogoče obdelati.');
  }
  context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) =>
        blob
          ? resolve(blob)
          : reject(new Error('Slike ni bilo mogoče obdelati.')),
      'image/webp',
      0.86,
    );
  });
}
